import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BomImportFormatDto } from './models/bom-import-format.dto';
import { BomImportPreviewDto } from './models/bom-import-preview.dto';
import { BomImportResultDto } from './models/bom-import-result.dto';

@Injectable({ providedIn: 'root' })
export class BomImportProvider {
  constructor(private http: HttpClient) {}

  getFormats(): Observable<BomImportFormatDto[]> {
    const url = '/api/bom/import/formats';
    return this.http.get<BomImportFormatDto[]>(url);
  }

  preview(file: File, format: string): Observable<BomImportPreviewDto> {
    const url = '/api/bom/import/preview';
    const formData = new FormData();
    formData.append('file', file);
    formData.append('format', format);
    return this.http.post<BomImportPreviewDto>(url, formData);
  }

  // The same file goes up again: the API re-parses it rather than trusting a tree sent back
  import(file: File, format: string, rootName: string, rootPartNumber: string): Observable<BomImportResultDto> {
    const url = '/api/bom/import';
    const formData = new FormData();
    formData.append('file', file);
    formData.append('format', format);
    formData.append('rootName', rootName);
    formData.append('rootPartNumber', rootPartNumber);
    return this.http.post<BomImportResultDto>(url, formData);
  }
}
